export enum PASSWORD_ERRORS {
  BLANK = 'Please fill out this field',
  INVALID = 'Incorrect password',
  MISMATCH = 'Passwords must match',
  MINIMUM = 'Password must be minimum of 8 characters',
  MAXIMUM = 'Password is too long (maximum is 128 characters)',
  DIFFERENT_PASSWORD = 'Password must be different from current password'
}
